import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || '';

export default function useLikes() {
  const [likedIds, setLikedIds] = useState(new Set());

  useEffect(() => {
    axios.get(`${API}/likes`)
      .then(r => setLikedIds(new Set((Array.isArray(r.data) ? r.data : []).map(Number))))
      .catch(() => {});
  }, []);

  const toggleLike = async (captureId) => {
    const isLiked = likedIds.has(Number(captureId));
    const newLiked = !isLiked;
    setLikedIds(prev => {
      const next = new Set(prev);
      newLiked ? next.add(Number(captureId)) : next.delete(Number(captureId));
      return next;
    });
    try {
      if (newLiked) {
        await axios.post(`${API}/likes/${captureId}`);
      } else {
        await axios.delete(`${API}/likes/${captureId}`);
      }
    } catch (e) {
      console.error('Like toggle failed:', e);
      setLikedIds(prev => {
        const next = new Set(prev);
        newLiked ? next.delete(Number(captureId)) : next.add(Number(captureId));
        return next;
      });
    }
  };

  return { likedIds, toggleLike };
}
